import { ReactNode, useState } from 'react';
import { CreditSubmissionAssignmentTitle } from '@trnsact/trnsact-shared-types';
import { Button, Divider, Stack, Typography, Box, Link } from '@mui/material';
import { UserProfile } from 'types';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { ModalsKeys } from 'global';
import { DetailsDialog } from '../dialogs';
import { useModal } from 'hooks/useModal';
import { ModalsContainer } from 'components/shared/Modals';
import { keyBy } from 'utils/arrayUtils';
import { getContactsAssignmentsForDetailsCard } from 'modules/creditSubmission/lib';
import { ContactAssignmentForCreditSubmissionDetails } from 'modules/creditSubmission/types';

interface Props {
  contacts: UserProfile[];
  initialContactsAssignments: CreditSubmissionAssignmentTitle[];
  creditSubmissionId: string;
}

const modalsWithKeys: Partial<Record<ModalsKeys, ReactNode>> = {
  [ModalsKeys.CreditSubmissionDetailsDialog]: <DetailsDialog />,
};

export const DetailsCard = ({ contacts, initialContactsAssignments, creditSubmissionId }: Props) => {
  const [contactsAssignments, setContactsAssignments] = useState<ContactAssignmentForCreditSubmissionDetails[]>(
    getContactsAssignmentsForDetailsCard(initialContactsAssignments, creditSubmissionId)
  );

  const { handleOpen: handleOpenDetailsDialog } = useModal(ModalsKeys.CreditSubmissionDetailsDialog);

  const contactsById = keyBy(contacts, 'id') as Record<string, UserProfile>;

  const handleEditClick = () => {
    handleOpenDetailsDialog({ contactsAssignments, setContactsAssignments, creditSubmissionId, contactsById });
  };

  return (
    <>
      <CardContainer
        title="Details"
        actionBtn={
          <Button size="small" onClick={handleEditClick}>
            Edit
          </Button>
        }
      >
        <Stack gap="1rem" divider={<Divider orientation="horizontal" flexItem />}>
          {contactsAssignments.map(assignment => (
            <Box key={assignment.title} sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
              <Typography variant="subtitle2" component="span">
                {assignment.title}
              </Typography>
              {assignment.userProfileId ? (
                <Link
                  underline="none"
                  target="_blank"
                  variant="body2"
                  href={`/profile/${contactsById[assignment.userProfileId]?.dynamicsContactId}`}
                >
                  {contactsById[assignment.userProfileId]?.fullName}
                </Link>
              ) : (
                <Typography variant="body2" component="span">
                  N/A
                </Typography>
              )}
            </Box>
          ))}
        </Stack>
      </CardContainer>

      <ModalsContainer modalsWithKeys={modalsWithKeys} />
    </>
  );
};
